/*=========================================================================================
  File Name: getters.js
  Description: Vuex Store - getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

const getters = {
  // COMPONENT
  // vx-autosuggest
  // starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),
  isManageAll: state => {
    return state.user &&
      state.user.role &&
      state.user.role.type == "manage_driver_trucks_purchase_tickets"
      ? true
      : false;
  },
  isManageTruckDriverOnly: state => {
    return state.user &&
      state.user.role &&
      state.user.role.type == "manage_drivers_trucks_only"
      ? true
      : false;
  },
  isClient: state => {
    return state.user &&
      state.user.role &&
      state.user.role.type == "authenticated"
      ? true
      : false;
  },
  isSuper: state => {
    return state.user &&
      state.user.role &&
      state.user.role.type == "super_admin"
      ? true
      : false;
  },
  isAdmin: state => {
    return state.user && state.user.role && state.user.role.type == "admin"
      ? true
      : false;
  },
  isAuth: state => {
    return state.user && state.user.role && state.user.role.id ? true : false;
  },
  initial: state => {
    let username = state.user.username;
    username = username.trim();
    if (!username.includes(" ")) return username.substr(0, 2).toUpperCase();
    return username;
  }
};

export default getters;
